// src/api/LeadershipApis.js
import apiClient from "../utils/Http";

// ── Public reads ──
export const getLeaders = () =>
  apiClient.get("api/leadership/");

export const getLeaderById = (id) =>
  apiClient.get(`api/leadership/${id}/`);

// ── Page visibility status ──
export const getLeadershipPageStatus = () =>
  apiClient.get("api/leadership-page-status/");

export const updateLeadershipPageStatus = (isEnabled) =>
  apiClient.patch("api/leadership-page-status/", {
    is_enabled: isEnabled,
  });

// ── Admin CRUD (staff only) ──
// Note: DO NOT set Content-Type manually for FormData.
// Axios sets it automatically with the multipart boundary.
export const createLeader = (formData) =>
  apiClient.post("api/leadership/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateLeader = (id, formData) =>
  apiClient.patch(`api/leadership/${id}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteLeader = (id) =>
  apiClient.delete(`api/leadership/${id}/`);